import React from 'react';
import '../css/Navbar.css';
import { SmoothScrollLink } from "organism-react-scroll-nav";


class Navbar extends React.Component {
  _isMounted = false;
    constructor(props) {
    super(props);
  
    this.state = {
      isTop: true
    };
    this.onScroll = this.onScroll.bind(this);
  }
  
  componentDidMount() {
    this._isMounted = true;
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop && this._isMounted) {
        this.onScroll(isTop);
        document.getElementById('navbar').classList.toggle("navbarScrooled");
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  
  onScroll(isTop) {
    this.setState({ isTop });
  }

  myRef = React.createRef();
  
  render() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-transparant fixed-top" id="navbar">
            <a className="navbar-brand" href="./">{/*<img src={logo} className="img-fluid" alt="logo" />*/}IKAEMERCE</a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto text-center">
                    <li className="nav-item active">
                      <SmoothScrollLink targetId="Home" > HOME </SmoothScrollLink>
                    </li>
                    <li className="nav-item active">
                      <SmoothScrollLink targetId="AboutUs" > ABOUT </SmoothScrollLink>
                    </li>
                    <li className="nav-item active">
                      <SmoothScrollLink targetId="Products"> PRODUCTS </SmoothScrollLink>
                    </li>
                    <li className="nav-item active">
                      <SmoothScrollLink targetId="OrderNow" className="nav-link rounded rounded-pill"> ORDER NOW </SmoothScrollLink>
                    </li>
                </ul>
            </div>
        </nav>
    );
  }
} 

export default Navbar;
